<lex-doc-viewer-context-panel-template>
  <div context-body style="overflow:auto;">
    <lex-doc-navigation-list [docListState]="docListContext"></lex-doc-navigation-list>
  </div>  
</lex-doc-viewer-context-panel-template>
